import React, { Component } from 'react';
import { metadata, studies, utils } from 'ohif-core';

import ConnectedCTViewer from './ConnectedCTViewer';
import PropTypes from 'prop-types';
import { extensionManager } from './../App';
import qs from 'query-string';
import { apis } from '../api';
import ImageError from '../components/Error/ImageError';

const { OHIFStudyMetadata } = metadata;
const { retrieveStudiesMetadata } = studies;
const { studyMetadataManager, updateMetaDataManager } = utils;

class CTViewerRetrieveStudyData extends Component {
  static propTypes = {
    studyInstanceUids: PropTypes.array.isRequired,
    seriesInstanceUids: PropTypes.array,
    sopInstanceUids: PropTypes.array,
    server: PropTypes.object,
    diagId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const search = qs.parse(window.location.search);
    this.state = { studies: null, error: null, ...search };
  }

  async componentDidMount() {
    // TODO: Avoid using timepoints here

    let {
      studyInstanceUids,
      seriesInstanceUids,
      sopInstanceUids,
      server,
      diagId,
    } = this.props;
    await apis.ctDcm4cheepath().then(res => {
      server = {
        ...server,
        qidoRoot: res.rs,
        wadoRoot: res.rs,
        wadoUriRoot: res.wado,
      };
    });

    const res = await apis.ctDicomList(diagId);
    const { data } = res;
    seriesInstanceUids = data.map(d => d.seriesUid);
    try {
      const studies = await retrieveStudiesMetadata(
        server,
        studyInstanceUids,
        seriesInstanceUids,
        sopInstanceUids
      );

      // Render the viewer when the data is ready
      // TODO: CLEAR THIS SOMEWHERE ELSE
      studyMetadataManager.purge();

      // Map studies to new format, update metadata manager?
      const updatedStudies = studies.map(study => {
        const studyMetadata = new OHIFStudyMetadata(
          study,
          study.studyInstanceUid
        );
        const sopClassHandlerModules =
          extensionManager.modules['sopClassHandlerModule'];

        study.displaySets =
          study.displaySets ||
          studyMetadata.createDisplaySets(sopClassHandlerModules);
        studyMetadata.setDisplaySets(study.displaySets);

        // Updates WADO-RS metaDataManager
        updateMetaDataManager(study);

        studyMetadataManager.add(studyMetadata);

        return study;
      });
      const newUpdatedStudies = updatedStudies[0];
      for (let i = 1; i < updatedStudies.length; i++) {
        newUpdatedStudies.displaySets.push(updatedStudies[i].displaySets[0]);
      }
      this.setState({ studies: [newUpdatedStudies] });
    } catch (err) {
      this.setState({ error: true });

      // TODO: Handle gracefully instead of throwing?
      throw new Error(err);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <ImageError title="因影像格式有异常，无法查看。如需帮助，请联系在线客服" />
      );
    }

    return (
      <ConnectedCTViewer
        studies={this.state.studies}
        studyInstanceUids={this.props.studyInstanceUids}
        seriesInstanceUids={this.props.seriesInstanceUids}
        sopInstanceUids={this.props.sopInstanceUids}
      />
    );
  }
}

export default CTViewerRetrieveStudyData;
